import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
//import 'firebase/admin'
//import * as admin from "firebase-admin";
import config from "./config";

export default {
  install(Vue: any, options: any) {
    // FireBaseの初期化処理
    const firebaseApp = firebase.initializeApp(config);

    // instance propertyの登録
    //Vue.prototype.$firebae = firebaseApp;
    Vue.prototype.$firestore = firebaseApp.firestore();
    Vue.prototype.$auth = firebaseApp.auth();
    //Vue.prototype.$admin = firebaseApp.admin();
    //Vue.prototype.$admin = admin;
    Vue.prototype.$signinStatus = "signed out";
    window.console.log("index.ts install() 1.");
    //window.console.log("index.ts install() 2." + this.$watanabe);
  }
};
